<h2 class="h4 pb-2">{{ 'meterPoint.meterPointChangeRequest.productAndDateStep.title' | translate }}</h2>
<div class="pb-3">
  <p [innerHTML]="'meterPoint.meterPointChangeRequest.productAndDateStep.addressInfo' | translate: translateParams()" class="mb-0"></p>
</div>
<form [formGroup]="this.form">
  @for (meterPoint of meterPoints(); track meterPoint.id) {
    <ikp-product-selection class="mt-2" [meterPoint]="meterPoint" [parentForm]="form" />
  }
</form>
